import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { fieldsMatcher } from '../../../../../../../src/app/website/utils/form.validators';
import { PASSWORD_VALIDATORS } from '../../../shared/validators/password-policy';
import { UserInvitation } from '../../../root/services/auth.service';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hfc-sign-up-password',
  templateUrl: './sign-up-password.component.html',
  styleUrls: ['./sign-up-password.component.scss']
})
export class SignUpPasswordComponent {
  @Input() userData: UserInvitation | null = null;
  @Output() complete = new EventEmitter<string>();

  public invitationSignUpFormGroup: UntypedFormGroup;

  constructor(public readonly tenantConfigService: TenantConfigService) {
    this.initialiseSignUpPasswordForm();
  }

  public submitPasswordIfValid(): void {
    if (this.invitationSignUpFormGroup.valid) {
      const password = this.invitationSignUpFormGroup.get('password')?.value;
      this.complete.emit(password);
    }
  }

  private initialiseSignUpPasswordForm(): void {
    this.invitationSignUpFormGroup = new UntypedFormGroup(
      {
        password: new UntypedFormControl('', PASSWORD_VALIDATORS),
        confirmPassword: new UntypedFormControl('', Validators.required)
      },
      fieldsMatcher('password', 'confirmPassword')
    );
  }
}
